import { render, staticRenderFns } from "./DanhGiaNDD.vue?vue&type=template&id=1d34c8d0&scoped=true"
import script from "./DanhGiaNDD.vue?vue&type=script&lang=ts"
export * from "./DanhGiaNDD.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d34c8d0",
  null
  
)

export default component.exports